import * as React from "react"
import { useSetRecoilState, useRecoilState } from "recoil"
import { Flex } from "@chakra-ui/react"

import layoutStates from "../../../recoil/atoms/layout"
import { LeaveOverlayProps } from "./leave-overlay.interface"
import { isBigPlayIconState } from "../../../recoil/atoms/bigPlayIcon"
import { MobileLocalButtons } from "../small-view/mobile-local-buttons"
import useLocalUserHasPermissions from "../../../hooks/useLocalUserHasPermissions"

// TODO - change the name to MainWindowOverlay
const _LeaveOverlay: React.FC<LeaveOverlayProps> = ({
  styling,
  isTouchDelay,
  handleTouchStart,
  handleTouchEnd,
  handleClickVideo,
  widthLeaveOverlay,
  isMainMobileScreen,
  heightLeaveOverlay,
  isCustomPlayer,
  isMobile,
  isVisible
}) => {
  const setHideLeaveButton = useSetRecoilState(layoutStates.hideLeaveButton)
  const setKeepLeaveOverlayActive = useSetRecoilState(layoutStates.keepLeaveOverlayActive)

  const setShowOnVideoOverlayContent = useSetRecoilState(
    layoutStates.showOnVideoOverlayContent
  )
  // const { isLandscape } = useRecoilValue(viewDependingLayoutAtom)
  const [isBigPlayIcon] = useRecoilState<boolean>(isBigPlayIconState)
  const { canUseCam, canUseMic } = useLocalUserHasPermissions()

  const unsetLeaveOverlayState = () => {
    setHideLeaveButton(false)
    setKeepLeaveOverlayActive(false)
    setShowOnVideoOverlayContent(true)
  }

  const hasCamOrMicPermission = canUseCam || canUseMic

  // Hide the leave overlay on mobile if cam or mic permission is not present
  const hideOverlay = !hasCamOrMicPermission && isMobile

  return (
    <Flex
      id="leave-overlay-container"
      style={{
        ...styling,
        width:
          widthLeaveOverlay !== false && widthLeaveOverlay !== undefined
            ? widthLeaveOverlay
            : "100%",
        background: "rgba(255,255,255,0.5)",
        alignSelf: "flex-start",
        height: heightLeaveOverlay ?? "100%",
        opacity: hideOverlay ? 0 : undefined
      }}
      className={isVisible ? "fast-appear" : undefined}
      flex={1}
      alignItems="center"
      justifyContent="center"
      position="absolute"
      zIndex={styling.zIndex}
      onClick={e => {
        if (isTouchDelay) {
          unsetLeaveOverlayState()
          handleClickVideo?.(e)
        }
      }}
      flexDirection="column"
    >
      {isMainMobileScreen && !isBigPlayIcon && (
        <MobileLocalButtons
          isMainMobileScreen={isMainMobileScreen}
          isMobile={isMobile}
        />
      )}
    </Flex>
  )
}

export const LeaveOverlay = React.memo(_LeaveOverlay)
